import ReactPerfTool from './components/ReactPerfTool';

// Import them styles
import './styles/reset.css';
import './styles/container.css';
import './styles/button.css';
import './styles/features.css';
import './styles/left-hand.css';
import './styles/right-hand.css';
import './styles/tabs.css';
import './styles/tools.css';
import './styles/settings.css';

export default ReactPerfTool;



/** WEBPACK FOOTER **
 ** ./src/index.js
 **/